import { React } from '../Imports';
import { Card, Typography, CardContent, Container } from '../MaterialUIComponents';
import { IEventReviewServiceInjectedProps, EventReviewService } from '../state/EventReviewFreezer';
import { IConfigServiceInjectedProps, ConfigService } from '$State/ConfigFreezerService';
import videoProtectsStackedLogo = require('../assets/videoProtectsStacked.png');
interface IDriverDiscussionSentBaseProps {}

type IDriverDiscussionSentProps = IDriverDiscussionSentBaseProps & IEventReviewServiceInjectedProps & IConfigServiceInjectedProps;

interface IDriverDiscussionSentState {
    errorMsg: string;
    id: string;
    token: string;
    passwordHasError: boolean;
}

const styles = require('./DriverDiscussionSent.scss') as {
    main: string;
    loginbutton: string;
    content: string;
    centeredText: string;
    buttonContainer: string;
    flex: string;
    bottomInfo: string;
    topInfo: string;
    logo: string;
};

class _DriverDiscussionSent extends React.Component<IDriverDiscussionSentProps, IDriverDiscussionSentState> {
    state: IDriverDiscussionSentState = {
        errorMsg: '',
        id: '',
        token: '',
        passwordHasError: false,
    };

    componentDidMount() {
        this.props.eventReview.resetRedirectTo();
    }

    render() {
        return (
            <Container className={styles.main}>
                <Card className={styles.content}>
                    <img className={styles.logo} src={videoProtectsStackedLogo} />
                    <CardContent className={styles.centeredText}>
                        <Typography variant="h5" component="h2" align="center" className={styles.centeredText}>
                            Your feedback has been sent to the fleet manager. You will be contacted soon for a discussion about your event.
                        </Typography>
                    </CardContent>
                </Card>
            </Container>
        );
    }
}

export const DriverDiscussionSentPage = EventReviewService.inject(ConfigService.inject(_DriverDiscussionSent));
